import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router';
import axios from 'axios'
import VuetifyDialog from "vuetify-dialog";
import "vuetify-dialog/dist/vuetify-dialog.min.css";
import VueCryptojs from 'vue-cryptojs'
import device from "vue-device-detector" 
import UUID from 'vue-uuid'
import SSE from 'vue-sse'
import Vuelidate from "vuelidate";

import routes from './routes';
import './registerServiceWorker'

import { JSEncrypt } from 'jsencrypt'

import { GlobalService } from './providers/GlobalService';
import { UserService } from './providers/UserService';
import { WebappService } from './providers/WebappService';

//import { StreamBarcodeReader } from "vue-barcode-reader";




const globalService = new GlobalService();
Vue.prototype.$globalService = globalService;

const userService = new UserService;
Vue.prototype.$userService = userService;

const webappService = new WebappService;
Vue.prototype.$webappService = webappService;

Vue.use(Vuelidate);
Vue.prototype.$encryptedData = function(publicKey, data) {
  let encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKey);
  let result = encrypt.encrypt(data);
  return result
}

Vue.config.productionTip = false
Vue.use(VueRouter,axios);
Vue.use(device);
Vue.use(VueCryptojs);
Vue.use(VuetifyDialog, {
  context: {
    vuetify
  }
});
Vue.use(UUID);
Vue.use(SSE);	
//Vue.use(StreamBarcodeReader);
const router = new VueRouter({routes});

new Vue({
  data: {
    menu: {},
    user:null,
    progress:false,
    token:null,
    tokenMode: false,
    ariadNextShowMode: 'Q', // Q: QRCODE, I: IFRAME',
    callbackUrl:null,
    callbackLibelle:null,
    uuid:null,
    webappData:null,
    //baseUrl:'http://localhost/sfrwebapp/',
    //baseUrl:'https://webapp.sfrcaraibe.fr/',
    errorMessage : "Une erreur s'est produite. Veuillez réessayer",
    confLogout: false,
    public_key : '-----BEGIN PUBLIC KEY-----'+
                'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDbTOvhXK26yM/gnCUWl86k8NWB'+
                'OLg2RieGnZ7Ifj3RJGA4mbyb07E2si76tIBINgmqffo84/M1nwyWAqSEJCNidfjE'+
                'OVUQxBvS3mSZ/5lPPoXtb9v7UqqLbRDAW+ShkjvEumf88yTVgpBhJeAie4EmzsTk'+
                'uoadqCSTG+OcyHh/4wIDAQAB'+
                '-----END PUBLIC KEY-----'
  },
  methods: {
    logout: function () { 
      if(this.webappData &&  (this.webappData.AZUREAD_ACTIVE && !this.webappData.existUserUuid)){
        console.log("logoutAzureAD");
        //const authUrl = "http://localhost/sfrwebapp/tests/simuasuradlogout.php"; // L'URL qui lance une webview
        const authUrl = this.$root.webappData.AZUREAD_URL_LOGOUT;
        console.log("open webview :", authUrl);
        window.open(authUrl, "_blank", "width=500,height=600");
      }else{
        sessionStorage.clear();
        
        localStorage.removeItem('access_token');
        localStorage.removeItem('access_token_expires_at');
        this.user = null;
        this.confLogout = false;
        this.$router.push({ path: '' }).catch(err => {
          // Ignore the vuex err regarding  navigating to the page they are already on.
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            throw err;
          }
        });
      }

    },
    logoutAzureAd: function () { 
      sessionStorage.clear();
      
      localStorage.removeItem('access_token');
      localStorage.removeItem('access_token_expires_at');
      this.user = null;
      this.confLogout = false;
      this.$router.push({ path: '' }).catch(err => {
        // Ignore the vuex err regarding  navigating to the page they are already on.
        if (
           err.name !== 'NavigationDuplicated' &&
           !err.message.includes('Avoided redundant navigation to current location')
        ) {
           // But print any other errors to the console
           throw err;
        }
     });

    },
    logoutToken: function () { 
      sessionStorage.clear();
      
      localStorage.removeItem('access_token');
      localStorage.removeItem('access_token_expires_at');
      this.token = null;
      this.callbackUrl = null;
      this.callbackLibelle = null;
      this.confLogout = false;
      

    },
    initSouscription: function(){
      sessionStorage.removeItem('souscription');
    }
  },
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')

// 💡 Instanciation des services avec accès à l'instance Vue
/*const globalService = new GlobalService(app);
const userService = new UserService(app);
const webappService = new WebappService(app);

// Mise à disposition dans Vue prototype
Vue.prototype.$globalService = globalService;
Vue.prototype.$userService = userService;
Vue.prototype.$webappService = webappService;*/